import type { BaseComponentProps } from "@neru/types";

import { COLORS } from "../../constants";
import { Icon, type IconType } from "../Icon/Icon";

export interface BannerProps extends BaseComponentProps {
  connotation?: "info" | "alert";
  message: string;
  open: boolean;
}

export const Banner = ({
  className,
  connotation = "info",
  "data-testid": testId = "banner",
  message,
  open,
}: BannerProps) => {
  const icon: IconType = `${connotation === "alert" ? "error" : connotation}-solid`;

  return open ? (
    <div
      className={className}
      data-testid={testId}
      style={{
        alignItems: "center",
        backgroundColor: COLORS.fixed[connotation]["500"],
        color: COLORS.fixed.primary["0"],
        display: "flex",
        justifyContent: "center",
        padding: "16px 24px 16px 24px",
      }}
    >
      <Icon
        customSize={20}
        data-testid={`icon-${icon}`}
        style={{ fill: COLORS.fixed.primary["0"] }}
        type={icon}
      />
      <span
        style={{
          fontWeight: "600",
          marginLeft: "1rem",
          paddingRight: "1rem",
        }}
      >
        {message}
      </span>
    </div>
  ) : null;
};
